import { WeaTools } from 'ecCom'

//获取表格信息
export const getSearchResult = ( params ) => {
  return WeaTools.callApi('/api/hrm/group/getSearchResult', 'POST', params);
}

//获取下拉面板中的组件
export const getSearchCondition = ( params ) => {
  return WeaTools.callApi('/api/hrm/group/getSearchCondition', 'GET', params);
}

//获取Dialog中的表单组件 
export const getFormCondition = ( params ) => {
  return WeaTools.callApi('/api/hrm/group/getHrmGroupForm', 'GET', params);
}

//保存"新建"表单
export const saveForm = ( params ) => {
  return WeaTools.callApi('/api/hrm/group/save', 'POST', params);
}

//常用组基本信息删除
export const deleteTableRow = ( params ) => {
  return WeaTools.callApi('/api/hrm/group/delete', 'POST', params);
}

//常用组导入历史记录下载
export const getImportHistoryFile = ( params ) => {
  return WeaTools.callApi('/api/hrm/group/getImportHistoryFile', 'GET', params);
}

//封存
export const doCancel = ( params ) => {
  return WeaTools.callApi('/api/hrm/group/doCancel', 'POST', params);
}

//解封
export const doISCanceled = ( params ) => {
  return WeaTools.callApi('/api/hrm/group/doIsCancel', 'POST', params);
}





// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/hrmgroup.js